import List from '@material-ui/core/List';
import PropTypes from 'prop-types';
import React from 'react';
import getLumpSumCodesAccordingToUserSpecialty from '../../../../../../../../utils/dataFetchers';
import CategoriesList from '../../../../../../../components/List/CategoriesList/CategoriesList';
import { ACTIVITIES_LUMP_SUM_TYPE } from '../../../../../../../../shared/collection/collectionConstants';

function LumpSumCodeList({ onItemSelected, onClose }) {
  return (
    <List dense>
      <CategoriesList
        list={getLumpSumCodesAccordingToUserSpecialty(ACTIVITIES_LUMP_SUM_TYPE)}
        onItemSelected={onItemSelected}
        onClose={onClose}
      />
    </List>
  );
}

LumpSumCodeList.propTypes = {
  onClose: PropTypes.func.isRequired,
  onItemSelected: PropTypes.func.isRequired
};

export default LumpSumCodeList;
